var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-account container py-4 mb-5"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-5 col-md-7 py-5"},[_c('change-password',{on:{"back":function($event){return _vm.$router.push({ name: 'account' })}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }